export default {
  FETCH_FILTERED_DASHBOARD_TASK: 'FETCH_FILTERED_DASHBOARD_TASK',
  FETCH_FILTERED_DASHBOARD_TASK_SUCCESS: 'FETCH_FILTERED_DASHBOARD_TASK_SUCCESS',
  FETCH_DASHBOARD_TASK: 'FETCH_DASHBOARD_TASK',
  FETCH_DASHBOARD_TASK_SUCCESS: 'FETCH_DASHBOARD_TASK_SUCCESS',
  EXPORT_TASK_TO_EXCEL: 'EXPORT_TASK_TO_EXCEL'
}
